import React from 'react';
import './copyBtn.scss';

const CopyBtn = (props) => {
    const text = props.text || '';
    const createFakeTextarea = (options = {}) => {
        const textAreaText = options.text || '';
        const textarea = document.createElement('textarea');
        textarea.style.position = 'absolute';
        textarea.style.left = '-999999px';
        textarea.style.top = '-99999px';
        textarea.style.zIndex = "-9999999";
        textarea.textContent = textAreaText;
        document.body.append(textarea);
        return textarea;
    };

    const getCoords = (elem) => {
        let box = elem.getBoundingClientRect();

        return {
            top: box.top + window.pageYOffset,
            left: box.left + window.pageXOffset
        };
    };
    const getSize = (elem) => {
        return {
            width: elem.offsetWidth,
            height: elem.offsetHeight,
        }
    };

    const showHint = (elem, options) => {
        const hintText = options && options.text || '';
        const lifetime = options && options.lifetime || 1000;
        const hint = document.createElement('span');
        hint.innerText = hintText;
        const coords = getCoords(elem);
        const elemSize = getSize(elem);
        hint.className = 'text-hint';
        document.body.append(hint);
        const hintSize = getSize(hint);
        hint.style.top = `${coords.top + (elemSize.height - hint.offsetHeight) / 2}px`;
        hint.style.left = `${coords.left - hintSize.width}px`;
        setTimeout(() => {
            hint.remove();
        }, lifetime)
    };

    const btnClickHandler = (e) => {
        const target = e.target;
        const codeText = text;
        const textarea = createFakeTextarea({text: codeText});
        textarea.focus();
        textarea.setSelectionRange(0, textarea.value.length);
        document.execCommand("copy");
        showHint(target, {text: 'Success'});
    };

    return (
        <div
            className="copy-btn"
            onClick={btnClickHandler}
        >
            {props.children}
        </div>
    )
};


export default CopyBtn;